/**
 * MODULE: _shared/frontend-shell/src/features/crm/hooks/useCrmAccountHealth.ts
 * PURPOSE: React Query hook for composite customer health score
 * PUBLIC_API: useCrmAccountHealth
 */

import { useQuery } from '@tanstack/react-query';
import { crmGetAccountHealth } from '@shared/lib/frontend/api/crmAccountHealthApi';

export function useCrmAccountHealth(accountId: string | null | undefined, enabled = true) {
  const id = accountId?.trim() || null;
  const query = useQuery({
    queryKey: ['crm', 'account-health', id],
    queryFn: () => crmGetAccountHealth(id!),
    enabled: Boolean(enabled && id),
    staleTime: 60_000,
  });

  return {
    health: query.data ?? null,
    loading: query.isLoading,
    error: query.error,
    refetch: query.refetch,
  };
}
